package com.eladfinish.bible.contest.screens.search.model

import androidx.compose.runtime.Stable
import kotlinx.collections.immutable.ImmutableList

@Stable
data class VerseUiModel(
    val id: String,
    val text: String,
    val source: String,
    val highlightedRanges: ImmutableList<IntRange>,
    val bookIndex: Int,
    val chapterIndex: Int,
    val verse: String,
)
